module.exports = __webpack_public_path__ + "static/media/iphone-1-landing-mobile.8aa00c19.png";